import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\dev\\cfs-website\\next\\components\\JotformCustomerSurveyEmbed.js");
